import { Button, ButtonStyle, connectDisconnectIntegration, createIntegrationData, getClientIntegrationData, getButtonClass, 
         getIntegrationsStatus, Image, imageSize, PageStyle, React, REDIRECT, Styles, Table, TableBody, TableCell, 
         TableContainer,  TableHead, TableRow, turnOnOffAccessibility, useEffect, useRouter, useState, useSWR, useTranslation, motion, PAGE_ANIMATION_OPTIONS, Filter,CompanyIntegrationAction , setIntegrationData , setDisabledIntegrationData,
         ErrorPages, ClientDashboard, SidebarAction, ActivitiesAction, SkipModal, CvLibrary, CustomToastrAction, Edit, Plus, Link, CONSTANTS, ConfirmationModal, Formik, getLinkedInJobsModal, getindeedModal, getTotalJobsModal} from "@/imports-files/pages/clients/activities/client-integrations";
         import QuickAdd from "@/components/quick-add";
import { CustomCompanyIntegrationModal } from "@/components/modals/custom-company-integration-modal";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { handleIntegrationSubmit, selectClientIntegrationTab } from "@/actions/pages/clients/activities/client-integrations";
import { Loading } from "@/components/loading";
import { CheckboxFilterModal } from "@/components/checkbox-filter-modal";
import { InputModal } from "@/components/input-modal";
import Modal from "@/components/common-modal/modal";

  export function CompanyIntegrations(props) 
  {
    const router                                                           =   useRouter('');
    const [apiError, setApiError]                                          =   useState(null);
    const activitiesAction                                                 =   new ActivitiesAction(setApiError);
    const errorPages                                                       =   new ErrorPages()
    const { data, error }                                                  =   useSWR('client_integration_data', () => { return(getClientIntegrationData(router, setApiError))}, { revalidateOnFocus: false });
    const [enable_integrations_array, set_enable_integrations_array]       =   useState([]);
    const [disable_integrations_array, set_disable_integrations_array]     =   useState([]);
    const { t, i18n }                                                      =   useTranslation();
    const [enable_items, setEnableItems] = useState('');
    const [custom_enable_items, setCustomEnableItems]                      =   useState('');
    const [isLoading, setLoadingStatus]                                    =   useState(true);
    const [formData, setFormData]                                          =   useState('');
    const [isEditable, setEditable]                                        =   useState(true);
    const step                                                             =   router.query.step
    const isQuickSetup                                                     =   router.query.step && router.query.step == 'company_integrations' ? true : false
    const [skipModal, setSkipModal]                                        =   useState(false);
    const [customTabModal, setCustomTabModal]                              =   useState(false);
    const customToastrAction                                               =   new CustomToastrAction(); 
    const [session, setSession]                                            =   useState(props.session);
    const [categoryList, setCategoryList]                                  =   useState('');
    const [flagForRerender, setFlagForRerender]                            =   useState(0);
    const [editIntegrationData, setEditIntegrationData]                    =   useState(null);
    const [integrationFilterModal, setIntegrationFilterModal]              =   useState(false)
    const [connectModal, setConnectModal] = useState(null)
    const [selectedRadio, setSelectedRadio] = useState(CONSTANTS.linkedInJobsModal.radios[0].defaultvalue || "");
    const companyIntegrationAction = new CompanyIntegrationAction(router)
    let selectedItem = []
    if (Array.isArray(enable_items) && enable_items.length > 0) {
       selectedItem = enable_items.find(
        item => item.slug === "linkedin-jobs"
      );
    }
    const linkedInJobsModal = getLinkedInJobsModal(t);
    const indeedModal = getindeedModal(t);
    const totalJobsModal = getTotalJobsModal(t);
    useEffect(async() => {
                        if(data)
                        {
                            if(session?.role == 'Administrator') setEditable(false)
                            const enableData = await setIntegrationData(data.enabled_integrations);
                            const disableData = await setDisabledIntegrationData(data.disabled_integrations);
                            set_disable_integrations_array(disableData);
                            setEnableItems(enableData);
                            setCategoryList(data.custom_integration_data.categories);
                            setCustomEnableItems(data.custom_integration_data.custom_integrations);
                            if(router.query?.success == 'true')
                            { 
                              customToastrAction.setNormalToastr(t('integrations:errors:connect_success'), 'success');
                              if(router.query?.step){
                                router.push({
                                  pathname: REDIRECT.client.quick_setup_page,
                                  query: {step: 'company_integrations'}
                                })
                              }
                              else {
                                window.history.replaceState(null, null, REDIRECT.client.client_integrations);  
                              }
                              router.query = {}
                            }
                            else if(router.query?.success == 'false') {
                              customToastrAction.setNormalToastr( router.query.message != null ? router.query.message : t('integrations:errors:connect_error'), 'warning');
                              // toastr.warning(t('page:clients:integrations:errors:connect_error')) 
                              if(router.query?.step){
                                router.push({
                                  pathname: REDIRECT.client.quick_setup_page,
                                  query: {step: 'company_integrations'}
                                })
                              }
                              else {
                                window.history.replaceState(null, null, REDIRECT.client.client_integrations);  
                              }
                              router.query = {}
                            }

                            if(isQuickSetup)
                              setTimeout(() => {
                                new SidebarAction().subsidebarQuickSetupChangeIcon( data.integration_data.data.sidebar_options.complete_steps, 'company_integrations');
                              }, 750);

                            setLoadingStatus(false);
                        } 
                    }, [data])

  if(isLoading || error || errorPages.handleErrorCodes(apiError?.status))
  {
    var renderPage  =  (error || apiError) ? errorPages.renderPage(error?.status || apiError?.status, router) : <Loading/>;
    return renderPage; 
  } 


  const initialValues = (values) =>{
    return {
      company_name: values?.company_name || "",
      campaign_tag: values?.campaign_tag || "",
    }
  }

  const linkedInJobsInitialValues = (values) =>{
    return {
      company_id: values?.company_id || "",
      contract_id: values?.contract_id || "",
    }
  }
  const totalJobsInitialValues = (values) =>{
    return {
      user_name: values?.user_name || "",
      password: values?.password || "",
    }
  }
  
  return (
    <>
      <div className = {`DashboardPageContent CompanyIntegration ${PageStyle.ClientCompany}`}>
        <motion.div initial="pageInitial"  animate="pageAnimate"  exit="pageExit"  variants={PAGE_ANIMATION_OPTIONS}  transition={{ delay: 0.2}}>
          <div className={PageStyle.ClientCompany__Container}>
            {/* <div className={PageStyle.ClientCompany__QuickAdd}>
              <Link href="/"> quick add </Link>
            </div> */}
            <div className={PageStyle.ClientCompany__TopSection2}>
              <div className={PageStyle.JobList__QuickAdd}>
                <QuickAdd session={session}/>
              </div>
            </div>
            
            
            <div className={PageStyle.ClientCompany__FormSection}>
              <h1 className={`${PageStyle.ClientCompany__Heading} mb0`}>
                {router.query.type == 'default' ?  t('integrations:company:heading')
                                               :  t('integrations:company:custom_heading')}
              </h1>

              <div>
                <h4 className={PageStyle.ClientCompany__Subheading2}>
                {t('integrations:company:subheading')}
                </h4>

           
              </div>

            </div>
           



            <Tabs defaultIndex  = {router.query.type == 'custom' ? 1 : 0}
                  onSelect      = {(index)=>{selectClientIntegrationTab(index, router, setEnableItems, setCustomEnableItems, setApiError, setCategoryList, setLoadingStatus)}}>
             <div className={`${PageStyle.SearchFlex}`}>
              <div className={`Tabsdesign`}>
                <TabList>
                  <Tab>{t('tabs:default')}</Tab>
                  <Tab>{t('tabs:custom')}</Tab>
                </TabList>
              </div>
              {router.query.type !== "custom" && (
              <div className={`${PageStyle.ClientCompany__Filter}`}>
                <Button
                  buttonstyle={`${ButtonStyle.iconFilled} ${companyIntegrationAction.isFilterApplied(router) ? ButtonStyle.iconFilledSolid : ButtonStyle.iconFilled}`}
                  onClick={() => {
                    setIntegrationFilterModal(!integrationFilterModal);
                  }}
                >
                   <Filter />
                </Button>
              </div>
            )}
            { router.query.type == 'custom' && 
              <div className={`AddIntegrationSection2 mb20`}>
                <Button buttonstyle={`${ButtonStyle.secondarybtn} buttonWithIcon`}onClick={() => { setEditIntegrationData('');  setCustomTabModal(true) }}>
                  <Plus />{t('button:add:integration')}
                </Button>
              </div>}
            
             </div>
                                                                    
              <div>
                <TabPanel>
                  {/* Default tab */}
                    <div className={Styles.IntegrationTable}>
                    {(enable_items.length + disable_integrations_array.length) > 0 ? <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell style={{width: "13%"}}>{t('datatable:integrations')}</TableCell>
                            <TableCell style={{width: "14%"}}></TableCell>
                            <TableCell style={{width: "60%"}}>{t('datatable:description')}</TableCell>
                            <TableCell style={{width: "20%"}}>{t('datatable:connect')}</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {enable_items.map((row, index) => (
                            <TableRow key={`enable_items_${index}`}>
                              <TableCell>{row.name}</TableCell>
                              <TableCell align="right">{row.logo}</TableCell>
                              <TableCell align="right"><p className={Styles.IntegrationTable__des}>{row.description}</p></TableCell>
                              {/* <TableCell align="right">{row.limit}</TableCell> */}
                              <TableCell align="right">
                                  <Button buttonstyle={getButtonClass(row, isEditable)} disabled={!isEditable} onClick={async (e) => { 
                                  if(row.is_linkable){
                                    const result = await connectDisconnectIntegration(e, router, row, setApiError, setFormData, setConnectModal)
                                    if(result && !result.connected)
                                    {
                                      enable_items[row.index] = result
                                      setEnableItems([...enable_items]);
                                    }
                                  }else
                                    { 
                                      turnOnOffAccessibility(e, row.slug, t, setApiError); 
                                    }
                                  }}>
                                  {getIntegrationsStatus(row, t)}
                                </Button>
                              </TableCell>
                            </TableRow>
                          ))}
                          {disable_integrations_array.map((row, index) => (
                            <TableRow key={`disable_integration_${index}`}>
                              <TableCell>{row.name}</TableCell>
                              <TableCell align="right">{row.logo}</TableCell>
                              <TableCell align="right"><p className={Styles.IntegrationTable__des}>{row.description}</p></TableCell>
                              {/* <TableCell align="right">{row.limit}</TableCell> */}
                              <TableCell align="right">
                                <Button buttonstyle={`${ButtonStyle.secondarybtn} ${ButtonStyle.GrayBgBtn}`}>
                                  {t('button:disabled')}
                                </Button>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                      </TableContainer> : <span className={`NoDataFound`}>{t('page:clients:my-integrations:texts:no_integrations')}</span>}
                    </div> 
                  {/* Default tab */}
                </TabPanel>
                <TabPanel>
                    <div className={`CustomIntegrationTable`}>
                      {(custom_enable_items?.length) > 0 ? <TableContainer>
                   <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell style={{width: "30%"}}>{t('datatable:domain')}</TableCell>
                        <TableCell style={{width: "30%"}}>{t('datatable:name')}</TableCell>
                        <TableCell style={{width: "30%"}}>{t('datatable:category')}</TableCell>
                        <TableCell style={{width: "10%"}}></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {custom_enable_items.map((row, index) => (
                        <TableRow key={`CustomIntegration_${index}`}>
                          <TableCell style={{width: "30%"}}>{row.domain}</TableCell>
                          <TableCell style={{ width: "30%" }}><p>{row.name}</p></TableCell>
                          <TableCell style={{ width: "30%" }}><p>{row.category_label}</p></TableCell>
                          <TableCell style={{ width: "10%" }}><p className={Styles.IntegrationTable__Action}><Edit onClick={() => { setEditIntegrationData(row); setCustomTabModal(true) }}/></p></TableCell>
                        </TableRow>
                      )) }
                    </TableBody>
                  </Table>
                  </TableContainer> : <div className={`NoDataFound`}>{t('integrations:company:no_integrations')}</div>}
                    </div> 
                </TabPanel>
              </div>
            </Tabs>
        
            

          {skipModal && <SkipModal setBtnPopup={setSkipModal} router={router}></SkipModal>}
          
          {/* { isQuickSetup && <div className={`space`}> */}
          {/*                               <div className= {`buttonolumngap ${Styles.Integration__SubmitSection}`}> */}
          {/*                               <Button buttonstyle={ButtonStyle.secondarybtnborder} type="button" onClick={() => { */}
          {/*                       setSkipModal(true)}}> Skip </Button> */}
          {/*                         <Button buttonstyle={ButtonStyle.primarybtn} type="button" onClick={()=>{ */}
          {/*                             activitiesAction.nextOnboardingStep(step, router) */}
          {/*                           }}> Next </Button> */}
          {/*                          */}
          {/*                               </div> */}
          {/*                             </div>} */}
          {isQuickSetup && <div className={`${Styles.SkipFinishButton} space`}>
            <div className= {`buttonolumngap ${Styles.Integration__SubmitSection}`}>
              <Button buttonstyle={ButtonStyle.secondarybtnborder} type="button" onClick={() => {
                setSkipModal(true)}}> {t('button:skip')} </Button>
              <Button buttonstyle={ButtonStyle.primarybtn} type="button" onClick={()=>{
                activitiesAction.nextOnboardingStep(step, router)
              }}> {t('button:next')}  </Button>
            </div>
          </div>}


          </div>
        </motion.div>
        
        </div>
        
        
        <CvLibrary trigger             =   {connectModal == "cvLibraryPaid"} editIntegrationData
                  row                  =   {enable_items.filter((x) => x.name == "CV-Library Paid")[0]} 
                  setCvLibraryModal    =   {setConnectModal}
                  setApiError          =   {setApiError}/>
                
        {customTabModal && <CustomCompanyIntegrationModal setModal            =  {setCustomTabModal}
                                                          categories          =  {categoryList}
                                                          setCustomEnableItems=  {setCustomEnableItems} 
                                                          setFlagForRerender  =  {setFlagForRerender}
                                                          data                =  {editIntegrationData}
                                                          setApiError         =  {setApiError}/>}
      {integrationFilterModal && (
        <CheckboxFilterModal
          closeState={setIntegrationFilterModal}
          modalHeight={'height450'}
          filters={data.integration_data.data.job_boards_listing}
          onSubmit={companyIntegrationAction.applyFilter}
          onSubmitParams={[
            setEnableItems,
            set_disable_integrations_array,
            router,
          ]}
        />
      )}
      {connectModal == "indeed" && (
        <InputModal
          initialValues={initialValues(formData)}
          {...indeedModal}
          closeState={setConnectModal}
          setFormData={setFormData}
          connectModal={connectModal}
          onSubmit={() => {
          setConnectModal("indeedConfirmation");
        }}
      />
      )}
      {connectModal == "totalJobs" && (
        <InputModal
          initialValues={totalJobsInitialValues(formData)}
          {...totalJobsModal}
          closeState={setConnectModal}
          setFormData={setFormData}
          connectModal={connectModal}
          onSubmit={() => {
            setConnectModal("totalJobsConfirmation");
          }}
        />
      )}
      {connectModal == "linkedInJobs" && (
        <InputModal
          initialValues={linkedInJobsInitialValues(formData)}
          {...linkedInJobsModal}
          closeState={setConnectModal}
          setFormData={setFormData}
          selectedItem={selectedItem}
          connectModal={connectModal}
          selectedRadio={selectedRadio}
          setSelectedRadio={setSelectedRadio}
          onSubmit={() => {
            setConnectModal("linkedInJobsconfirmation");
          }}
        />
      )}
      {connectModal == "linkedInJobsconfirmation" && (
        <Modal
          type="confirmation"
          message={t('modal:input_modal:confirm_modal:description')}
          closeModal={() => {
            setConnectModal("linkedInJobs");
          }}
          btnAction={() => {
            handleIntegrationSubmit(
              formData,
              enable_items.filter((x) => x.name === "LinkedIn Jobs")[0],
              router,
              setConnectModal,
              setApiError
            );
          }}
          texts={{
            button1_text: t('button:edit'),
            button2_text: t('button:confirm'),
          }}
          heightClass="height400 width600"
        />
      )}
      {connectModal == "indeedConfirmation" && (
        <Modal
          type="confirmation"
          message={t('modal:input_modal:confirm_modal:description')}
          closeModal={() => {
            setConnectModal("indeed");
          }}
          btnAction={() => {
            handleIntegrationSubmit(
              formData,
              enable_items.filter((x) => x.name === "Indeed")[0],
              router,
              setConnectModal,
              setApiError
            );
          }}
          texts={{
            button1_text: t('button:edit'),
            button2_text: t('button:confirm'),
          }}
          heightClass="height400 width600"
        />
      )}
      {connectModal == "totalJobsConfirmation" && (
         <Modal
          type="confirmation"
          message={t('modal:input_modal:confirm_modal:description')}
          closeModal={() => {
            setConnectModal("totalJobs");
          }}
          btnAction={() => {
            handleIntegrationSubmit(
              formData,
              enable_items.filter((x) => x.name === "Total Jobs")[0],
              router,
              setConnectModal,
              setApiError
            );
          }}
          texts={{
            button1_text: t('button:edit'),
            button2_text: t('button:confirm'),
          }}
        />
      )}
   </>
  );
  }

  CompanyIntegrations.layout = ClientDashboard;
  export default CompanyIntegrations;